import Vue from 'vue'
const __getByteLength = (str) => {
  let len = 0;
  for (let i = 0; i < str.length; i++) {
    if (str.charCodeAt(i) >= 0x4e00 && str.charCodeAt(i) <= 0x9fa5) {
      len += 2;
    } else {
      len++;
    }
  }
  return len;
}
const DEFAULT_RULES = {
  required: function(val) {
    return !!(val && !/^(?:\s|\u3000)+$/.test(val));
  },
  email: "^\\w+((-\\w+)|(\\.\\w+))*\\@[A-Za-z0-9]+((\\.|-)[A-Za-z0-9]+)*\\.[A-Za-z0-9]+$",
  mobile: "^1[0-9]{10}$",
  mobileOrtel: "(^(14|15|17|18)[0-9]{9}$)|(^(([0\\+]\\d{2,3}-)?(0\\d{2,3})-)?(\\d{7,8})(-(\\d{3,}))?$)",
  mobileOrEmail: "(^\\w+((-\\w+)|(\\.\\w+))*\\@[A-Za-z0-9]+((\\.|-)[A-Za-z0-9]+)*\\.[A-Za-z0-9]+$)|(^(13|14|17|15|18)[0-9]{9}$)",
  tel: "^(([0\\+]\\d{2,3}-)?(0\\d{2,3})-)?(\\d{7,8})(-(\\d{3,}))?$",
  telephone: "^[0-9]{6,12}$", //渠道内网座机校验规则：6-12位数字
  url: "^http[s]?:\\/\\/\.*$",
  username: "^\\w+$",
  qq: "^[1-9]\\d{5,}$",
  number: "^\\d+$",
  num: "^([+-]?)\\d*\\.?\\d+$", //数字
  num1: "^[1-9]\\d*|0$", //正数（正整数 + 0）
  num2: "^-[1-9]\\d*|0$", //负数（负整数 + 0）
  intege: "^-?[1-9]\\d*$",
  intege1: "^[1-9]\\d*$",
  positiveDecimal: "/^[\+]?\d*(\.\d+)?$/",
  decmal: "^[0-9]\\d*(\\.\\d{1,2})?$", //正浮点数
  decmal2: "^[0-9]\\d*(\\.\\d{1,2})?$", //正浮点数,
  idcard: "^[1-9]([0-9]{14})|[0-9]{17}([0-9]|[A-Za-z])$",
  letterAndNum: "(?!^[0-9]*$)(?!^[a-zA-Z]*$)^([a-zA-Z0-9]{2,})$",
  onlyCH: "^[\\u2E80-\\u9FFF]+$",
  onlyNum: "^[0-9]\\d*|0$", //可以0开头
  idCardNumber: function(sId, opt) {
    let iSum = 0;
    let info = "";
    let idReg = new RegExp("^[1-9]([0-9]{14})|[0-9]{17}([0-9]|[A-Za-z])$");
    let aCity = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外" };
    if (!idReg.test(sId)) {
      return false;
    }
    sId = sId.replace(/x$/i, "a");
    if (aCity[parseInt(sId.substr(0, 2))] == null) {
      return false;
    }
    let sBirthday = sId.substr(6, 4) + "-" + Number(sId.substr(10, 2)) + "-" + Number(sId.substr(12, 2));
    let d = new Date(sBirthday.replace(/-/g, "/"));
    if (sBirthday != (d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate())) {
      return false;
    }
    for (let i = 17; i >= 0; i--) {
      iSum += (Math.pow(2, i) % 11) * parseInt(sId.charAt(17 - i), 11)
    }
    if (iSum % 11 != 1) {
      return false;
    };
    return true;
  },
  maxlength: function(val, opt) {
    return __getByteLength(val) <= opt;
  },
  minlength: function(val, opt) {
    return __getByteLength(val) >= opt;
  },
  rangelength: function(val, opt) {
    return val.length >= opt[0] && val.length <= opt[1];
  },
  equal: function(val, opt) {
    return val === (typeof opt == "function" ? opt() : opt);
  }
}
const __match = (name, val, item, callback, opt, options) => {
  let me = this,
    rule = DEFAULT_RULES[name],
    param = opt && opt.param;

  if (typeof val == "string") {
    val = val.trim();
  }
  if (typeof param == "function") {
    callback(param(val, options.ctx));
  } else {
    if (typeof rule == "function") {
      callback(rule(val, param), opt.ctx);
    } else {
      callback(new RegExp(rule).test(val));
    }

  }
}
const validateField = (item, value, options, callback) => {
  const { rule, id } = item;
  const itemCallback = item.callback;
  let entry, resultList = [];
  if (rule && id) {
    for (let key in rule) {
      entry = rule[key];
      if (rule["required"] || value != "") {
        __match(key, value, item, function(rs) {
          if (!rs) {
            resultList.push({
              type: key,
              field: id,
              result: rs,
              message: entry.message
            });
          }
        }, {
          param: entry.hasOwnProperty('param') ? entry.param : entry
        }, options);
      }
    }
  }
  itemCallback && itemCallback(value, resultList.length <= 0);
  typeof callback == "function" && callback(value, resultList.length <= 0, resultList);
}

const checkForm = (config, formData, options = {}) => {
  let keyList = config,
    resultList = [],
    params = {},
    result = false

  return new Promise((resolve, reject) => {
    keyList.forEach(item => {
      const id = item.id;
      const value = formData[id];
      validateField(item, value, options, (val, rs, list) => {
        if (list.length > 0) {
          resultList = resultList.concat(list.shift());
          return false;
        }
        if (rs) {
          params[id] = val !== undefined ? `${val}`.trim() : val;
        }
      });
    });
    if (resultList.length > 0) {
      if (resultList[0].message) {
        Vue.prototype.$toast(resultList[0].message);
      }
      return false;
    }
    result = resultList.length <= 0 ? true : false;
    resolve({
      params,
      result,
      resultList
    })
  })
}

checkForm.isMobile = (v) => {
  return new RegExp(DEFAULT_RULES.mobile).test(v);
}

export default checkForm
